import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TFactoryShiftState } from './factory-shift.models';

export const getFactoryShiftState = (state: TPlani8State) => state.factoryShiftInfo;

export const getFactoryShiftInfo = createSelector(
  getFactoryShiftState,
  (state: TFactoryShiftState) => state.factoryShiftInfo,
);

export const getFactoryHolidayInfo = createSelector(
  getFactoryShiftState,
  (state: TFactoryShiftState) => state.factoryHolidayInfo,
);

export const getShiftCategoryTab = createSelector(
  getFactoryShiftState,
  (state: TFactoryShiftState) => state.shiftCategoryTab,
);
